export const testimonials = [
  {
    quote: "CaringHands gave our family peace of mind. The caregiver assigned to my mother was incredibly kind and attentive.",
    name: "Sarah M.",
    role: "Daughter",
    rating: 5
  },
  {
    quote: "After my surgery, I needed help at home. The team was professional, punctual, and truly caring.",
    name: "Robert J.",
    role: "Client",
    rating: 5
  },
  {
    quote: "We tried other services before, but none matched the warmth and reliability of CaringHands.",
    name: "Linda & Tom K.",
    role: "Family",
    rating: 5
  }
];
